export enum MenuRoutePaths {
  menuRoot = '/menu',
}

export enum AboutRoutePaths {
  aboutRoot = '/about',
}

export enum UserRoutePaths {
  userRoot = '/users',
  userAddPath = '/user/new',
  userEditPath = '/user/edit/:userId',
}

export enum ProfileRoutePaths {
  profileRoot = '/profile',
}

export enum AuthorRoutePaths {
  authorRoot = '/authors',
  authorAddPath = '/author/new',
  authorEditPath = '/author/edit/:authorId',
  authorBooksPath = '/author/books/:authorId',
}

export enum SerieRoutePaths {
  serieRoot = '/series',
  serieAddPath = '/serie/new',
  serieEditPath = '/serie/edit/:serieId',
  serieBooksPath = '/serie/books/:serieId',
}

export enum BookRoutePaths {
  bookRoot = '/books',
  bookAddPath = '/book/new',
  bookEditPath = '/book/edit/:bookId',
}
